// extracted by mini-css-extract-plugin
export default {"container":"LookupCaptcha_container__1EWih","inner":"LookupCaptcha_inner__Q7F-G"};